import { render, staticRenderFns } from "./MyCreatedTask.vue?vue&type=template&id=54fdeed6&"
import script from "./MyCreatedTask.vue?vue&type=script&lang=js&"
export * from "./MyCreatedTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports